import axios from 'axios'
import {AuthModel, CreateUser, UserModel} from './_models'
import { User } from '../../apps/user-management/users-list/core/_models';

const API_URL = process.env.REACT_APP_API_URL;
const API_ASSEMP_URL = process.env.REACT_APP_ASSEMP_URL
const API_ASSEMP_URL2 = process.env.REACT_APP_ASSEMP_URL_2

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const RECOVER_PASSWORD = `${API_ASSEMP_URL}/security-ms/usuario/senha`
export const EXPIRED_PASSWORD = `${API_ASSEMP_URL}/security-ms/usuario/senha/direta`
export const FORGOT_PASSWORD = `${API_ASSEMP_URL}/security-ms/usuario/senha/esqueceuSenha`


// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const CREATE_USER = `${API_ASSEMP_URL}/security-ms/usuario`;
export const LOGIN = `${API_ASSEMP_URL}/security-ms/login`
export const GET_ALL_COURSES = `${API_ASSEMP_URL}/nucleo-ms/api/cursos`
export const GET_ALL_SECTORS = `${API_ASSEMP_URL}/nucleo-ms/api/setor`
export const GET_COURSE_SECTORS = `${API_ASSEMP_URL}/nucleo-ms/api/setor/cursos`
export const GET_PROFESSOR_BY_SECTOR = `${API_ASSEMP_URL}/nucleo-ms/api/cursos/professor/setor`
export const GET_ALL_PROFESSORS = `${API_ASSEMP_URL}/nucleo-ms/api/cursos/professor`
export const GET_ALL_STUDENTS = `${API_ASSEMP_URL}/nucleo-ms/api/participante`
export const SET_STUDENT_TO_COURSE = `${API_ASSEMP_URL}/nucleo-ms/api/cursos/matricula`
export const GET_ALL_PERMISSIONS = `${API_ASSEMP_URL}/security-ms/usuario/permissoes`


// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,  
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(login: string) {
  return axios.post<{result: boolean}>(RECOVER_PASSWORD, {
    login: login,
  })
}

export function forgotPassword(login: string) {
  return axios.post<{result: boolean}>(FORGOT_PASSWORD, {
    login: login,
  })
}

export function recoverPassword(currentUser: any, passwordForm: any) {
  const resp = axios.put(RECOVER_PASSWORD, {
    usuario: currentUser.idUsuario,
    senhaAntiga:passwordForm.oldPassword,    
    novaSenha:passwordForm.newPassword,
    novaSenhaConfirma:passwordForm.confirmPassword
  }, {
    headers: {
      'Authorization': `Bearer ${currentUser.token}`
    }
  })
  return resp
}

export function expiredPassword(currentUser: any, passwordForm: any) {
  const resp = axios.put(EXPIRED_PASSWORD, {
    usuario: currentUser.idUsuario,
    novaSenha:passwordForm.newPassword,
    novaSenhaConfirma:passwordForm.confirmPassword
  },{
    headers: {
      'Authorization': `Bearer ${currentUser.token}`
    }
  })
  return resp
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function createUser(payload: CreateUser) {
  return axios.post<CreateUser>(CREATE_USER, {
    payload
  })
}

export function loginAssemp(payload) {
  return axios.post<User>(
    // 'http://18.231.230.180:58912/login',
    LOGIN, 
    payload
  ,{
    headers: {
      // 'Access-Control-Allow-Origin': 'http://localhost:3011',
      // 'Content-type': 'application/json'
    }
  })
}


export async function getAllSectors() {
  const resp = await axios.get(GET_ALL_SECTORS)
  return resp.data
}

export async function getCourseSectors() {
  const resp = await axios.get(GET_COURSE_SECTORS)
  return resp.data
}

export async function getAllProfessors() {
  const resp = await axios.get(GET_ALL_PROFESSORS)
  return resp.data
}

export async function getProfessorBySector(sector: string) {
  const resp = await axios.get(`${GET_PROFESSOR_BY_SECTOR}/`+sector)
  return resp
}

export async function getAllStudents(nome?: string, codemp?: string, matricula?: string, cpf?: string) {
  const resp = await axios.get(GET_ALL_STUDENTS, {
    params: {
        nome : nome,
        codemp : codemp,
        matricula : matricula,
        cpf : cpf,
        status: true
    }
  })
  return resp.data
}
 
export async function addStudentOnCourse(studentId : number, courseId: number){
    const resp = await axios.post(SET_STUDENT_TO_COURSE, {
        idAluno : studentId,
        idCurso : Number(courseId)
    }) 
    return resp
}

export async function getAllPermissions(){
    const resp = await axios.get(GET_ALL_PERMISSIONS);
    return resp
}